import React, { useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import homeSvg from "../../assets/dashboard/home1.svg";
import styles from "./BreadCrumbs.module.css";
import rightArrow from "../../assets/dashboard/rightArrow.svg";
import { AppContext } from "../../ContextApi/AppContext/AppContext";

const Breadcrumbs = () => {
  const { state } = useContext(AppContext);
  const { stepLanguage, language } = state;
  const location = useLocation();
  const pathnames = location.pathname.split("/").filter((x) => x);

  // Adjust validPathnames based on language
  const validPathnames = pathnames.map((name) => {
    if (language === "de") {
      if (name === "consumption-certificate") {
        return "Verbrauchsausweis";
      } else if (name === "energy-certificate") {
        return "Bedarfsausweis";
      }
    }
    return name;
  });


  return (
    <nav aria-label="breadcrumb">
      <div 
        className={styles.breadCrumbContainer}
        style={{ textTransform: language === "en" ? "none" : "capitalize" }}
      >
        {validPathnames.map((name, index) => {
          const routeTo = `/${pathnames.slice(0, index + 1).join("/")}`;
          const isLast = index === validPathnames.length - 1;

          return isLast ? (
            <div
              key={name}
              className={`${styles.bread} ${styles.activeBreadCrumb}`}
              aria-current="page"
            >
              {index === 0 && (
                <img src={homeSvg} alt="" className={styles.imgClass} />
              )}
              <span>
                <img src={rightArrow} alt="" /> {name}
              </span>
            </div>
          ) : (
            <div
              key={name}
              className={`${styles.bread} ${styles.inActiveBreadCrumb}`}
            >
              {index === 0 && (
                <img src={homeSvg} alt="" className={styles.imgClass} />
              )}
              <Link to={routeTo}>
                <img src={rightArrow} alt="" /> {name}
              </Link>
            </div>
          );
        })}
      </div>
    </nav>
  );
};

export default Breadcrumbs;
